module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Bounce</h1>\n</div>\n<iframe src=\"apps/bounce/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/bounce/bounce.component.html
// module id = ../../../../../src/app/pages/bounce/bounce.component.html
// module chunks = main